import useQuery from '@/core/hooks/api/useQuery';
import Api from '@/core/lib/new-architecture/api';
import type { Query } from '@/core/lib/new-architecture/query/types.query';
import type { DocumentsFileResult } from '@/core/types/document';

const keys = {
  base: ['KEY_TO_PREVENT_COLLISIONS', '/document'] as const,
  cgu: (version: string = 'latest') => [...keys.base, '/cgu', version] as const,
};

interface DocumentsParams {
  version?: string;
}

const useCgu: Query<DocumentsFileResult, DocumentsParams> = () => {
  return useQuery({
    queryKey: keys.cgu(),
    queryFn: async () => Api.query.documents.cgu(),
    retry: 0,
  });
};

useCgu.prefetch = async ({ queryClient }) => {
  await queryClient.prefetchQuery({
    queryKey: keys.cgu(),
    queryFn: () => Api.query.documents.cgu(),
  });
};

export default { useCgu };
